export default __webpack_public_path__ + "static/23665-0e0c2b386930f57e1d7b9868f2485e38.jpg";